import React, { useContext } from 'react'
import { CellRenderer, CellContentProps } from '../../legacy-design-system/grid'
import { Route } from '../../graphql/schema/types/route'
import { css } from '@emotion/css'
import { RouteContext } from '../route-provider'
import {
  getApplicationVulnerabilitiesRoute,
  getApplicationDrilldownID
} from '../route'
import { WithTooltip } from '../../design-system'
import { FormattedMessage } from 'react-intl'
import { Link } from '@contrast-security-inc/design-system-typography'
import { CountBadge } from '@contrast-security-inc/design-system-badges'

export const vulnerabilitiesCellTestID = 'vulnerabilities-cell-test-id'

export function getVulnerabilitiesCellRenderer(): CellRenderer<Route> {
  return function vulnerabilitiesCellRenderer(props) {
    return <VulnerabilitiesCell {...props} />
  }
}

function VulnerabilitiesCell({
  rowData: { hash, exercised, vulnerabilityCount, criticalVulnerabilityCount },
  getCellContentProps
}: {
  readonly rowData: Route
  readonly getCellContentProps: (props: {}) => CellContentProps
}) {
  const { parameters, organizationID: organizationUuid } =
    useContext(RouteContext)

  const applicationUuid = getApplicationDrilldownID(parameters)

  const isLink = exercised && vulnerabilityCount > 0

  return (
    <div
      data-testid={vulnerabilitiesCellTestID}
      {...getCellContentProps({
        className: css`
          display: flex;
          align-items: center;
        `
      })}
    >
      <>
        <Link
          className={css`
            padding-right: 3px;
          `}
          color="neutral100"
          isDisabled={!isLink}
          href={
            organizationUuid && applicationUuid && isLink
              ? `${getApplicationVulnerabilitiesRoute(
                  organizationUuid,
                  applicationUuid
                )}?quickFilter=ALL&routes=${hash}`
              : ''
          }
        >
          {exercised ? vulnerabilityCount : '-'}
        </Link>
        {criticalVulnerabilityCount > 0 && (
          <div
            className={css`
              font-size: 11px;
            `}
          >
            <WithTooltip
              tiny
              placement="top"
              renderTooltipContent={() => (
                <FormattedMessage
                  id="detail_vulnerabilities_criticalVulns"
                  values={{ count: criticalVulnerabilityCount }}
                />
              )}
              children={() => (
                <CountBadge
                  className={css`
                    padding: 1px 5px 1px;
                  `}
                  data-testid="warning-count-badge"
                  color="red50"
                  count={criticalVulnerabilityCount}
                />
              )}
            />
          </div>
        )}
      </>
    </div>
  )
}
